import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import SharedDialog from "../../features/dialogBox/dialogBox";
import ReactionPostDialog from "../dialogBox/ReactionPostDialog";
import DynamicSnackbar from "../../features/snackbar/Snackbar";
import ConfirmDialogBox from "../../features/confirmDialogBox/confirmDialogBox";
import CreatePostDialog from "../dialogBox/CreatePostDialog";
import { useDispatch, useSelector } from "react-redux";
import { closeConfirmDialog } from "../../features/confirmDialogBox/confirmDialogBoxSlice";
import ApiService from "../../utils/ApiService";
import { openSnackbar } from "../../features/snackbar/snackbarSlice";
import { useLocation, useNavigate } from "react-router-dom";
import ReportTextField from '../../component/forms/TextField';
import encriptionHelper from '../../utils/encriptionHelper';

const Dialogs = ({ reportComment, feedPostData, deleteComment, currentCommentId, setAnchorEl }) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate();
    const [reportPostComment, setReportPostComment] = useState('');
    const [currentPostDelete, setCurrentPostDelete] = useState('');
    const [reportTextComment, setReportTextComment] = useState('');
    const [currentCommentReport, setCurrentCommentReport] = useState('');
    const [currentPostReport, setCurrentPostReport] = useState('');
    const userData = useSelector((state) => state?.user?.userListName)
    // const searchParams = encriptionHelper().decryptURLParams(window.location.search.substring(1).split("&")[0].split("=")[1]);
    const searchParams = location?.state || JSON.parse(localStorage.getItem("state"));
    const reactPost = searchParams['reactPost'] ?? location?.reactPost ?? 'reactPost';

    const closeDialogDeletePostPublish = () => {
        dispatch(closeConfirmDialog('ConfirmDeletePost'));
    }

    const closeDialogPublish = () => {
        dispatch(closeConfirmDialog('ConfirmDialog'));
    }

    const closeDialogPostReportPublish = () => {
        setReportPostComment('');
        dispatch(closeConfirmDialog('ReportPostDialog'));
    }

    const closeDialogCommentReportPublish = () => {
        dispatch(closeConfirmDialog('ReportDialog'));
    }
    const handleCommentButtonClick = (feedPostComments, postData) => {
        handleConfirm()
    };
    const handleConfirm = () => {
        let api = reactPost == 'reactPost' ? 'deleteComment' : 'DeleteComment';
        if (currentCommentId.id == currentPostDelete || !currentCommentId.id) {
            return;
        }
        setCurrentPostDelete(currentCommentId.id);
        ApiService.delete(api, {}, currentCommentId.id)
            .then((response) => {
                if (response.status === 200) {
                    deleteComment(currentCommentId.id);
                    dispatch(openSnackbar({ dataLoad: true, message: response?.data?.data[0].title, severity: "info" }));
                    closeConfirmDialog();
                }
                closeDialogPublish();
                dispatch(closeConfirmDialog('ConfirmDialog'));
            })
            .catch((error) => {
                dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
                setCurrentPostDelete('');
            });
        setAnchorEl(null);
    };

    const handleDialogDeletePostPublish = () => {
        ApiService.delete('deletePost', {}, feedPostData.id)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(closeConfirmDialog('ConfirmDeletePost'));
                    navigate('/');
                }
                dispatch(openSnackbar({ dataLoad: true, message: response?.data?.data[0].title, severity: "info" }));
                // console.log('aaaa', response?.data?.data)
                // } 
            })
            .catch((error) => {
                dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
            }
            );
    }

    const handleReport = () => {
        if (currentCommentId.id == currentCommentReport) {
            return;
        }
        setCurrentCommentReport(currentCommentId.id);
        let api = reactPost == 'reactPost' ? 'CommentReport' : 'userCommentReport';
        let payload = new FormData();
        payload.append('userId', userData.userId);
        payload.append('commentId', currentCommentId.id);
        payload.append('report', reportTextComment);
        ApiService.postAdopter(api, payload)
            .then((response) => {
                if (response.status === 200) {
                    reportComment(currentCommentId.id);
                    dispatch(openSnackbar({ dataLoad: true, message: response?.data?.data[0].title, severity: "info" }));
                    // setIsLoading(true);
                    closeConfirmDialog();
                    setCurrentCommentReport('');
                    setReportTextComment('');
                }
                closeDialogPublish();
                dispatch(closeConfirmDialog('ReportDialog'));
            })
            .catch((error) => {
                dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
                setCurrentCommentReport('');
            });
    };
    const handleReportPostClick = () => {
        if (feedPostData.id == currentPostReport) {
            return;
        }
        setCurrentPostReport(feedPostData.id);
        let api = reactPost == 'reactPost' ? 'ReportPost' : 'userPostReport';
        let payload = new FormData();
        payload.append('userId', userData.userId);
        if (reactPost == 'reactPost') {
            payload.append('postId', feedPostData.id);
        } else {
            payload.append('post_id', feedPostData.id);
            payload.append('post_type', feedPostData.type);
        }
        payload.append('report', reportPostComment);
        ApiService.postAdopter(api, payload)
            .then((response) => {
                console.log({ response })
                if (response.status === 200) {
                    dispatch(openSnackbar({ dataLoad: true, message: "Post reported successfully.", severity: "info" }));
                    setCurrentPostReport('');
                    setReportPostComment('');
                }
                closeDialogPublish();
                dispatch(closeConfirmDialog('ReportPostDialog'));
            })
            .catch((error) => {
                dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
                setCurrentPostReport('');
            });
        setAnchorEl(null);
    }
    return (
        <Box>
            <SharedDialog id="reactionDialog">
                <ReactionPostDialog id="reactionDialog" mode={'Reaction'} />
            </SharedDialog>
            <DynamicSnackbar />
            <ConfirmDialogBox
                id='ConfirmDialog'
                title="Delete"
                body={<p>Are you sure you want to delete this comment? This will remove the comment and can't be undone.</p>}
                onCancel={closeDialogPublish}
                onConfirm={handleCommentButtonClick}
                titleOne="Cancel"
                titleTwo="Delete"
            />

            <ConfirmDialogBox
                id='ConfirmDeletePost'
                title="Delete"
                body={<p>Are you sure you want to delete this post? This will remove the post and can't be undone.</p>}
                onCancel={closeDialogDeletePostPublish}
                onConfirm={handleDialogDeletePostPublish}
                titleOne="Cancel"
                titleTwo="Delete"
            />

            <ConfirmDialogBox
                id='ReportDialog'
                title="Report the comment"
                body={
                    <Box sx={{ '& .MuiFormControl-root': { mt: 2, width: "-webkit-fill-available" } }}>
                        <ReportTextField id="outlined-basic" label="Description" multiline maxRows={4} variant="outlined" setTextField={setReportTextComment} value={reportTextComment} />
                    </Box>}
                onCancel={closeDialogCommentReportPublish}
                onConfirm={handleReport}
                titleOne="Cancel"
                titleTwo="Report"
                disableConfirmBtn={reportTextComment}
            />

            <ConfirmDialogBox
                id='ReportPostDialog'
                title="Report the post"
                body={
                    <Box sx={{ '& .MuiFormControl-root': { mt: 2, width: "-webkit-fill-available" } }}>
                        <ReportTextField id="outlined-basic" label="Description" multiline maxRows={4} variant="outlined" setTextField={setReportPostComment} value={reportPostComment} />
                    </Box>}
                onCancel={closeDialogPostReportPublish}
                onConfirm={handleReportPostClick}
                disableConfirmBtn={reportPostComment}
                titleOne="Cancel"
                titleTwo="Report"
            />

            <SharedDialog id="editDialog">
                <CreatePostDialog id="editDialog" mode={'edit'} />
            </SharedDialog>
        </Box>
    )
}
export default Dialogs;